export default __webpack_public_path__ + "static/media/set_7_Page-6.14644eb1.svg";